import {
  createEmptyChangeAddressForm,
  type ChangeAddressFormModel,
} from './useFormPayload';

function trim(v: unknown): string {
  if (v === null || v === undefined) return '';
  return String(v).trim();
}

/**
 * L_TASK_EFILING_DATA.FORM_DATA JSON → ChangeAddressForm model
 */
export function parseEfilingFormDataToChangeAddressModel(
  fd: Record<string, any> | null | undefined,
): ChangeAddressFormModel {
  const m = createEmptyChangeAddressForm();
  if (!fd || typeof fd !== 'object') return m;

  m.companyName = trim(fd.company_name ?? fd.companyName);
  m.companyRegistrationNo = trim(fd.company_registration_no ?? fd.companyRegistrationNo);
  m.dated = trim(fd.dated ?? fd.addressEffectiveDate ?? fd.resolutionDate);

  const addr = fd.officeAddr ?? fd.office_addr;
  if (addr && typeof addr === 'object') {
    m.officeAddr.postalCode = trim(addr.postalCode ?? addr.postal_code);
    m.officeAddr.blkHseNo = trim(addr.blkhseNo ?? addr.blkHseNo ?? addr.blockNo);
    m.officeAddr.streetName = trim(addr.streetName ?? addr.street_name);
    m.officeAddr.buildingName = trim(addr.buildingName ?? addr.building_name);
    m.officeAddr.levelNo = trim(addr.levelNo ?? addr.level_no ?? addr.level);
    m.officeAddr.unitNo = trim(addr.unitNo ?? addr.unit_no ?? addr.unit);
    m.officeAddr.haveLevelUnit = addr.haveLevelUnit !== false;
  }

  return m;
}
